import { EnumFeatureFlagName, FeatureFlagApiResponse } from '@blank/api'
import { apiClient } from 'modules/common/http/apiClient'

interface Props {
  featureName: EnumFeatureFlagName
  baseURL: string
}

export const fetchFeatureFlag = async ({ featureName, baseURL }: Props) => {
  const apiUrl = `/corporate-v2/v1/feature-flags/${featureName}`

  const { data } = await apiClient.get<{ body: FeatureFlagApiResponse }>(
    apiUrl,
    {
      baseURL,
      timeout: 5000,
    }
  )

  return data
}
